import { isAxiosError } from 'axios';

/**
 * React Query `retry` predicate: avoid hammering the API on client errors (4xx).
 * Retries transient failures (network, 5xx, 429) up to `maxRetries` times.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const maxRetries = 2;
  if (failureCount >= maxRetries) return false;

  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status !== undefined && status >= 400 && status < 500) {
      if (status === 408 || status === 429) return true;
      return false;
    }
    return true;
  }

  return true;
}
